const footer = $('.footer-parent');
const socialsNav = footer.find('.footer-socials');
const footerNavs = footer.find('.footer-navs');
const leftContent = footer.find('.left-content');
const footerTopBtn = footer.find('.back-top-parent');

const footerChangeNavLayout = () => {
  if (isDesktop()) {
    const footerLastNavColumn = footer.find('.footer-content .nav-block').last();
    footerTopBtn.css('width', `${pxToVw(footerLastNavColumn.width())}vw`);
    leftContent.prepend(socialsNav);
  } else {
    footerTopBtn.css('width', 'fit-content');
    footerNavs.append(socialsNav);
  }
};

const footerBackTopHover = () => {
  const backTopArrows = $('footer .back-top-icon');
  footerTopBtn.on('mouseenter', () => {
    gsap.fromTo(
      backTopArrows,
      {
        y: '0',
      },
      {
        y: `-100%`,
        duration: 0.667,
        ease: 'pageInEasing',
      }
    );
  });
};

const footerAnimation = () => {
  ScrollTrigger.refresh();
  const footerTrigger = $('footer .footer-navs');
  const footerGroup = $('footer .footer-group');
  const lineParent = $('.footer-line-parent');
  const footerTL = isDesktop() ? gsap.timeline({ paused: true, onComplete: footerBackTopHover }) : false;
  const footerBtn = $('footer .button-parent');
  const leftContentItem = $('footer .left-content-item');

  if(footerTL){
    leftContentItem.each(function (index) {
      const itemDelay = 0.1 * index;
      footerTL.add(
        gsap.fromTo(
          $(this),
          {
            y: '3.75vw',
          },
          {
            y: '0%',
            duration: 0.833,
            ease: 'pageInEasing',
          }
        ),
        itemDelay
      );
      footerTL.add(
        gsap.fromTo(
          $(this),
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.5,
            ease: 'pageInEasing',
          }
        ),
        itemDelay + 0.33
      );
    });

    footerGroup.each(function (index) {
      const groupDelay = 0.1 * (index + 1);
      const footerGroupItems = $(this).find('.nav-item');
      footerTL.add(
        gsap.fromTo(
          $(this),
          {
            y: '2.5vw',
          },
          {
            y: '0%',
            duration: 0.833,
            ease: 'pageInEasing',
          }
        ),
        groupDelay
      );

      footerTL.add(
        gsap.fromTo(
          $(this),
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.5,
            ease: 'pageInEasing',
          }
        ),
        groupDelay + 0.33
      );
      footerTL.add(
        gsap.fromTo(
          footerGroupItems,
          {
            y: '1.875vw',
          },
          {
            y: '0%',
            duration: 0.833,
            stagger: {
              each: 0.067,
            },
          }
        ),
        groupDelay + 0.033 * index
      );
      footerTL.add(
        gsap.fromTo(
          footerGroupItems,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.667,
            stagger: {
              each: 0.067,
            },
          }
        ),
        groupDelay + 0.033 * index
      );
    });

  }

  const lineTL = addLoopLineAnimation(lineParent);
  /*
  const lineTL = gsap.timeline({ paused: true, repeat: -1 }).add(
    lineSvgAnimation(lineParent, {
      fromTop: '-18.938vw',
      toTop: '100%',
      duration: 5,
    }).play(),
    0
  );
  */

  ScrollTrigger.create({
    trigger: footerTrigger,
    start: 'top bottom-=10%',
    end: 'top top',
    once: true,
    onEnter: () => {
      footerTL ? footerTL.play() : false;
      lineTL.play();
    },
  });
};

const initFooterAnimation = () => {
  footerChangeNavLayout();
  footerAnimation();
  mobileNavControl($('footer'));
}

$(window).on('deviceChange', function () {
  footerChangeNavLayout();
  mobileNavControl($('footer'));
});

/*
$(window).on('heroReady', function () {
  initFooterAnimation()
});
*/

addSectionObserver(footer, initFooterAnimation);
